import { useCurrentSessionUser } from '@ms/yammer-hooks/dist/session';

import { UseUIFeatureCheck } from '../types';

export const useIsGroupsEnabled: UseUIFeatureCheck = () => {
  const { isGuest } = useCurrentSessionUser();

  return !isGuest;
};
